module.exports = __webpack_public_path__ + "static/img/Megaphone-On.e21a19dd.png";